import type from './ProductCP.type';

const initialState = {
  unarchivedCardsList: [],
  totalCards: 0,
  supplierList: [],
  individualDetail: null,
  productCpTabs: [],
  productCpColumnTabs: null,
  totalproductCp: 0,
  pcpLogs: [],
  totalCount: 0,
  fetchtabColumns: [],
  calculationData: [],
};

const ProductCPReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_UNARCHIVED_CARDS:
      return {
        ...state,
        unarchivedCardsList: [...(state.unarchivedCardsList || []), ...(action.payload?.data || [])],
        totalCards: action.payload?.totalCards,
      };
    case type.GET_ALL_SUPPLIERS:
      return {
        ...state,
        supplierList: action.payload,
      };
    case type.GET_INDIVIDUAL_DETAILS:
      return {
        ...state,
        individualDetail: action.payload,
      };
    case type.GET_ALL_TAB_COLUMDATA: {
      const { payload } = action;
      const existing = state.productCpColumnTabs;
      const isPartial =
        payload?.totalCount > 0 &&
        Array.isArray(payload?.productDetails) &&
        payload.productDetails.length < payload.totalCount &&
        existing?.productDetails?.length > 0;

      let mergedProductDetails = payload?.productDetails ?? [];
      if (isPartial) {
        const isPOBased = state.individualDetail?.basedOnPO === true;
        const seen = new Set(
          (existing.productDetails || []).map((item) =>
            isPOBased ? item?.rowKey : `${item?.productId ?? item?._id}_${item?.colourId ?? 'null'}_${item?.supplierId ?? 'null'}_${item?.factoryId ?? 'null'}`,
          ),
        );
        const appended = (payload.productDetails || []).filter((item) => {
          const key = isPOBased
            ? item?.rowKey
            : `${item?.productId ?? item?._id}_${item?.colourId ?? 'null'}_${item?.supplierId ?? 'null'}_${item?.factoryId ?? 'null'}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        mergedProductDetails = [...(existing.productDetails || []), ...appended];
      }

      const productCpColumnTabs = payload ? { ...payload, productDetails: mergedProductDetails } : payload;

      return {
        ...state,
        productCpColumnTabs,
        totalproductCp: payload?.totalCount ?? state.totalproductCp,
      };
    }
    case type.CLEAR_TABS:
      return {
        ...state,
        productCpTabs: [],
      };
    case type.CLEAR_INDIVIDUAL_REDUCER:
      return { ...state, individualDetail: null, productCpColumnTabs: null, productCpTabs: [] };
    case type.CLEAR_TABLE_REDUCER:
      return {
        ...state,
        totalproductCp: 0,
        productCpColumnTabs: null,
      };
    case type.CLEAR_REDUCER:
      return {
        ...state,
        unarchivedCardsList: [],
        totalCards: 0,
        totalproductCp: 0,
        productCpColumnTabs: null,
      };
    case type.ALL_PRODUCTCP_TABLIST:
      return {
        ...state,
        productCpTabs: action.payload,
      };
    case type.GET_PCP_LOGS:
      return {
        ...state,
        pcpLogs: [...state.pcpLogs, ...action.payload.logs],
        totalCount: action.payload.totalCount,
      };
    case type.GET_TAB_COLUMNS:
      return {
        ...state,
        fetchtabColumns: action.payload,
      };
    case type.CLEAR_LOGS_REDUCER:
      return {
        ...state,
        pcpLogs: [],
        totalCount: 0,
      };
    case type.GET_NEW_CALCULATION:
      return {
        ...state,
        calculationData: action.payload,
      };

    default:
      return state;
  }
};

export default ProductCPReducer;
